<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="globe" />
          {{$t('title')}}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('keyword')"></b-form-input>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{$t('search')}}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <!-- c-paging -->
      <div class="col-12">
        <div class="c-sorting">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <button @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus" />&nbsp;{{$t('create')}}
                </button>
              </div>
            </div>
            <!-- col -->
          </div>
          <!-- row -->
        </div>
        <!-- c-sorting -->
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{$t('found', [itemCount])}}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- c-paging -->
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-1"></div>
            <div class="col-lg-3">{{$t('name')}}</div>
            <div class="col-lg-3">{{$t('info')}}</div>
            <div class="col-lg-3">{{$t('status')}}</div>
            <div class="col-lg-2"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-1">
              <a :href="item.image" target="_blank">
                <figure  class="c-board-table__avatar">
                  <img :src="item.imageURL" class="thumbnail" alt="..." />
                </figure>
              </a>
            </div>
            <div class="col-lg-3">
              <b class="c-smart-table__label">{{$t('name')}}: </b>
              <span>{{item.name}}</span>
            </div>
            <div class="col-lg-3">
              <div class="mb-1">
                <b>{{ $t('price') }}: </b>
                <del v-if="item.listPrice">{{ item.listPrice| numFormat }}</del>
                <del v-else>{{$t('free')}}</del>&nbsp;
                <span v-if="item.sellPrice">{{ item.sellPrice | numFormat }}</span>
                <span v-else>{{$t('free')}}</span>
              </div>
              <div class="mb-1">
                <b>{{ $t('desc') }}: </b> <span v-if="item.desc">{{ item.desc }}</span><span v-else>{{$t('notUpdated')}}</span>
              </div>
              <div class="mb-1">
                <b>{{ $t('subject') }}: </b> <span v-if="item.subject">{{ item.subject }}</span><span v-else>{{$t('notUpdated')}}</span>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="mb-1">
                <span v-if="item.active" class="badge badge-success">{{ $t('activated')}} </span>
                <span v-else class="badge badge-danger">{{ $t('notActivated')}} </span>
              </div>
              <div class="mb-1">
                <b>{{ $t('createTime') }}: </b> <span>{{ item.createTime | moment('DD/MM/YYY HH:mm')}}</span>
              </div>
              <div>
                <b>{{ $t('updateTime') }}: </b> <span>{{ item.updateTime | moment('DD/MM/YYY HH:mm')}}</span>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col">
                    <button @click="update(item._id)" type="button"
                            class="btn btn-sm btn-info mr-1">
                      <font-awesome-icon icon="edit" />&nbsp;{{$t('edit')}}
                    </button>
                    <button @click="del(item._id)" type="button" class="btn btn-sm btn-danger mr-1">
                      <font-awesome-icon icon="trash" />&nbsp;{{$t('delete')}}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{$t('notFoundCreate')}}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{$t('notFoundSearch')}}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{$t('found', [itemCount])}}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
    <b-modal v-model="showForm" size="xl" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
      <form-input :label="$t('name')" :model="formModel" attribute="name" :errors="formErrors"></form-input>
      <div>
        <label>{{$t('image')}}</label> <br>
        <img alt="img" style="max-height: 180px" class="img-thumbnail mb-2" :src="formModel.imageURL">
        <form-file :multiple="false" service="/upload/upload-image" :model="imageModel" attribute="image" :errors="formErrors" accept="image/jpeg,image/jpg" />
      </div>
      <form-input :label="$t('desc')" :model="formModel" attribute="desc" :errors="formErrors"></form-input>
      <form-input :label="$t('listPrice')" :model="formModel" attribute="listPrice" :errors="formErrors"></form-input>
      <form-input :label="$t('sellPrice')" :model="formModel" attribute="sellPrice" :errors="formErrors"></form-input>
      <form-input :label="$t('subject')" :model="formModel" attribute='subject' :errors="formErrors"></form-input>
      <form-email-editor :model="formModel" attribute="content" :errors="formErrors"
                         :label="$t('content')" :placeholder="$t('content')">
      </form-email-editor>
      <form-checkbox :model="formModel" :errors="formErrors" attribute="active"
                     :chk-label="$t('activated')">
      </form-checkbox>
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button size="md" variant="secondary" @click="cancel()">{{$t('cancel')}}</b-button>
        <b-button size="md" variant="primary" @click="ok()">{{$t('save')}}</b-button>
      </template>
    </b-modal>
  </main>
</template>
<script>
import List from '@/mixins/List';
import CRUD from "@/mixins/CRUD";
export default {
  mixins: [List, CRUD],
  data: function() {
    return {
      service: '/email-template-caliio',
      defaultFormModel: {
        imageURL: null
      },
      autoLoad: true,
      imageModel: {
        image: null
      }
    }
  },
  watch: {
    "imageModel.image": function (val) {
      if (val && val.length) {
        this.formModel.image = val[0].fileHash;
        this.formModel.imageURL = val[0].url;
      }
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'Email template',
        name: 'Name',
        desc: 'Description',
        subject: 'Subject',
        content: 'Content',
        notActivated: 'Not activated',
        listPrice: "List price",
        sellPrice: "Sell price",
        image: "Image",
        free: "Free",
      },
      vi: {
        title: 'Mẫu email mặc định',
        name: 'Tên',
        desc: 'Mô tả',
        subject: 'Tiêu đề email',
        content: 'Nội dung email',
        notActivated: 'Không hoạt động',
        listPrice: "Giá cũ",
        sellPrice: "Giá bán",
        image: "Ảnh",
        free: "Miễn phí",
      }
    }
  },
  methods: {}
}
</script>